<div [attr.class]="type"></div>
